// Generated by openapi-codegen. Do not edit manually.

import * as z from 'zod';
import { v1ForbiddenErrorSchema } from './v1/forbiddenErrorSchema';
import { v1NotFoundErrorSchema } from './v1/notFoundErrorSchema';

export const delete11AccountIdTeamsIdPathParamsSchema = z.object({
  account_id: z.number().int().describe("Account ID for the team you want to delete"),
  id: z.number().int().describe("Team ID to delete"),
});

export const delete11AccountIdTeamsIdQueryParamsSchema = z.object({
  delete_project_users: z.optional(z.boolean().describe("Whether to delete users from team projects")),
}).optional();

export const delete11AccountIdTeamsIdHeaderParamsSchema = z.object({
  Authorization: z.optional(z.coerce.string()),
});

/**
 * @description Team deleted successfully
 */
export const delete11AccountIdTeamsId200Schema = z.object({});

/**
 * @description Forbidden - Insufficient permissions to delete team
 */
export const delete11AccountIdTeamsId403Schema = z.lazy(() => v1ForbiddenErrorSchema);

/**
 * @description Team not found
 */
export const delete11AccountIdTeamsId404Schema = z.lazy(() => v1NotFoundErrorSchema);

export const delete11AccountIdTeamsIdMutationResponseSchema = z.lazy(() => delete11AccountIdTeamsId200Schema);
